/* Import leaflet from Patternslib */

// Core
import registry from "@patternslib/patternslib/src/core/registry";

// Patternslib patterns
import "@patternslib/pat-leaflet/src/leaflet";

registry.init();
